import {AllRegister} from './poly/registers/All';

AllRegister.registerAll();
